import axios from "axios";

const BASE_ROUTE = "document-analysis";

// El backend espera a OpenAI (hasta ~120 s por documento); el timeout del cliente debe ser
// mayor para no cortar una respuesta valida.
export const ANALYSIS_TIMEOUT_MS = 180000;

export const ANALYSIS_STATUS = {
    COMPLETED: "COMPLETED",
    FAILED: "FAILED",
};

/** Tipos habilitados en el backend: [{ key, label, mimeTypes, maxMb }] */
export const getDocumentTypes = () => axios.get(`${BASE_ROUTE}/types`);

/**
 * Sube y analiza un archivo. Responde 201 tambien si el analisis falla (status FAILED):
 * el documento queda guardado. Los demas errores (422 archivo invalido, 503 storage)
 * llegan como rechazo con el mensaje en error.response.data.
 */
export const analyzeDocument = (documentType, file, { onUploadProgress } = {}) => {
    const formData = new FormData();
    formData.append("document_type", documentType);
    formData.append("file", file);
    return axios.post(BASE_ROUTE, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: ANALYSIS_TIMEOUT_MS,
        onUploadProgress,
    });
};

export const getDocumentAnalysis = (analysisUuid) =>
    axios.get(`${BASE_ROUTE}/${analysisUuid}`);

/** Liga al caso los analisis hechos antes de que existiera (el caso se crea despues). */
export const linkDocumentAnalyses = (caseSlug, analysisUuids) =>
    axios.put(`${BASE_ROUTE}/link`, { caseSlug, analysisUuids });

/** Analisis ya ligados al caso (documentos cargados y datos que se leyeron de ellos). */
export const getCaseDocumentAnalyses = (caseSlug) =>
    axios.get(`${BASE_ROUTE}/case/${caseSlug}`);
